const initUnwrapText = () => {
  let blocks = document.querySelectorAll(
    '[data-new-reviews] .reviews-block__description'
  );

  blocks.forEach((it) => {
    if (it.offsetHeight > 134) {
      it.nextElementSibling.style.display = 'block';
      it.classList.add('roll');

      it.nextElementSibling.addEventListener('click', (e) => {
        if (it.classList.contains('roll')) {
          e.target.textContent = 'Свернуть';
        } else {
          e.target.textContent = 'Развернуть кейс';
        }
        it.classList.toggle('roll');
      });
    }
  });
};

export default initUnwrapText;
